import styles from "./player-remaining-time.module.css";

export const RemainingTime = "div";
export const RemainingTimeClassName = styles.remainingTime;

export const Time = "p";
export const TimeClassName = styles.time;

export const Separator = "p";
export const SeparatorClassName = styles.separator;
